module.exports = __webpack_public_path__ + "static/media/birthdaypartyparrot.2339bcf3.gif";